import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'antd';
import styles from './styles';

const closeAnimationDuration = 250;

export const RBHAlert = (props: any) => {
  const [isAutoCloseCompleted, setIsAutoCloseCompleted] = useState(false);

  useEffect(() => {
    if (!!props.autoCloseDuration && props.autoCloseDuration > 0) {
      setTimeout(() => {
        if (!!props.onClose) {
          props.onClose();
        }
      }, props.autoCloseDuration);

      setTimeout(() => {
        if (!!props.afterClose) {
          props.afterClose();
        }
        setIsAutoCloseCompleted(true);
      }, props.autoCloseDuration + closeAnimationDuration);
    }
  }, [])

  return !!props.autoCloseDuration && props.autoCloseDuration > 0 && isAutoCloseCompleted ? null :
    <Alert
      style={styles.formText}
      type={props.type}
      showIcon
      closable
      afterClose={props.afterClose}
      message={
        <FormattedMessage id={props.text} values={props.values} />
      }
    >
      {props.children}
    </Alert>
};

type Props = {
  autoCloseDuration?: number
};

export default RBHAlert;
